export type Option<V = string> = {
  text: string;
  value: V;
  label?: string;
  description?: string;
  type?: OptionType;
  id?: string;
};

export enum OptionTextLayout {
  STACK = 'stack',
  INLINE = 'inline',
}

export enum OptionType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}
